const AUDIT_SUBMISSIONS_KEY = 'dopomogai:website-v2:audit-submissions';
const WIDGET_HANDOFFS_KEY = 'dopomogai:website-v2:widget-handoffs';

const appendStoredRecord = (key: string, value: unknown) => {
  if (typeof window === 'undefined') return;

  try {
    const current = window.localStorage.getItem(key);
    const parsed = current ? (JSON.parse(current) as unknown[]) : [];
    parsed.push(value);
    window.localStorage.setItem(key, JSON.stringify(parsed));
  } catch {
    window.localStorage.setItem(key, JSON.stringify([value]));
  }
};

export const persistAuditSubmission = async (payload: unknown) => {
  appendStoredRecord(AUDIT_SUBMISSIONS_KEY, {
    submittedAt: new Date().toISOString(),
    payload,
  });

  await new Promise((resolve) => window.setTimeout(resolve, 450));
};

export const persistWidgetHandoff = async (payload: unknown) => {
  appendStoredRecord(WIDGET_HANDOFFS_KEY, {
    submittedAt: new Date().toISOString(),
    payload,
  });

  await new Promise((resolve) => window.setTimeout(resolve, 300));
};
